import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export const LANGS = ["de", "en", "fr"];

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const stored = localStorage.getItem("nerochar-lang");
    return LANGS.includes(stored) ? stored : "de";
  });

  const setLang = useCallback((code) => {
    if (!LANGS.includes(code)) return;
    localStorage.setItem("nerochar-lang", code);
    setLangState(code);
  }, []);

  const value = { lang, setLang, t: translations[lang] };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
